module.exports = __webpack_public_path__ + "static/team-2-cf8a9ccbfbc9b3f5a5a3bc2b1f62e1af.png";